// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SelectTextInputController from "./select_text_input_controller"
application.register("select-text-input", SelectTextInputController)
